export const UPDATE_FORM_STEP = "UPDATE_FORM_STEP";

export const UPDATE_STEP_1_STATE = "UPDATE_STEP_1_STATE";
export const UPDATE_STEP_2_STATE = "UPDATE_STEP_2_STATE";
export const UPDATE_STEP_3_STATE = "UPDATE_STEP_3_STATE";
export const UPDATE_STEP_4_STATE = "UPDATE_STEP_4_STATE";
export const UPDATE_STEP_5_STATE = "UPDATE_STEP_5_STATE";
export const UPDATE_STEP_6_STATE = "UPDATE_STEP_6_STATE";
export const UPDATE_STEP_7_STATE = "UPDATE_STEP_7_STATE";
export const UPDATE_STEP_8_STATE = "UPDATE_STEP_8_STATE";
export const UPDATE_STEP_9_STATE = "UPDATE_STEP_9_STATE";
export const UPDATE_STEP_10_STATE = "UPDATE_STEP_10_STATE";
export const UPDATE_STEP_11_STATE = "UPDATE_STEP_11_STATE";